module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1502-retro.8d9a6ccc.jpg";